
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components & App components
 |--------------------------------------------------------------------------
 */

require('../spark-components/bootstrap')

require('./kiosk/candidates')
